"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioVoiceServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
let AudioVoiceService = class AudioVoiceService extends client_1.RWSService {
    constructor(apiService) {
        super();
        this.apiService = apiService;
    }
    /**
     * Get available voices from ElevenLabs
     */
    async getVoices() {
        try {
            const response = await this.apiService.back.get('audio.voices');
            return response;
        }
        catch (error) {
            console.error('Failed to fetch voices:', error);
            return {
                success: false,
                error: error.message || 'Failed to fetch voices'
            };
        }
    }
    /**
     * Get voice by ID
     */
    async getVoiceById(voiceId) {
        try {
            const response = await this.apiService.back.get('audio.voice-by-id', { routeParams: { voiceId } });
            return response;
        }
        catch (error) {
            console.error('Failed to fetch voice:', error);
            return {
                success: false,
                error: error.message || 'Failed to fetch voice'
            };
        }
    }
    /**
     * Get recommended voices
     */
    async getRecommendedVoices() {
        try {
            const response = await this.apiService.back.get('audio.recommended-voices');
            return response;
        }
        catch (error) {
            console.error('Failed to fetch recommended voices:', error);
            return {
                success: false,
                error: error.message || 'Failed to fetch recommended voices'
            };
        }
    }
    /**
     * Get user info (usage stats, etc.)
     */
    async getUserInfo() {
        try {
            const response = await this.apiService.back.get('audio.user-info');
            return response;
        }
        catch (error) {
            console.error('Failed to fetch user info:', error);
            return {
                success: false,
                error: error.message || 'Failed to fetch user info'
            };
        }
    }
    /**
     * Filter voices by category
     */
    filterVoicesByCategory(voices, category) {
        return voices.filter(voice => voice.category === category);
    }
    /**
     * Search voices by name or description
     */
    searchVoices(voices, query) {
        const searchTerm = query.toLowerCase();
        return voices.filter(voice => voice.name.toLowerCase().includes(searchTerm) ||
            voice.description.toLowerCase().includes(searchTerm));
    }
    /**
     * Get voice categories from a list of voices
     */
    getVoiceCategories(voices) {
        const categories = new Set(voices.map(voice => voice.category));
        return Array.from(categories);
    }
    /**
     * Sort voices by name
     */
    sortVoicesByName(voices, ascending = true) {
        return [...voices].sort((a, b) => {
            const comparison = a.name.localeCompare(b.name);
            return ascending ? comparison : -comparison;
        });
    }
    /**
     * Get default voice for different use cases
     */
    getDefaultVoice(category = 'conversation') {
        const defaultVoices = {
            conversation: 'pNInz6obpgDQGcFmaJgB', // Adam
            professional: 'VR6AewLTigWG4xSOukaG', // Arnold
            casual: 'TxGEqnHWrfWFTfGW9XjX' // Josh
        };
        return defaultVoices[category];
    }
    /**
     * Validate voice ID format
     */
    isValidVoiceId(voiceId) {
        // ElevenLabs voice IDs are typically 20 characters long
        return typeof voiceId === 'string' && voiceId.length === 20;
    }
};
exports.AudioVoiceServiceInstance = AudioVoiceService;
exports.AudioVoiceServiceInstance = AudioVoiceService = __decorate([
    __param(0, client_1.ApiService),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object])
], AudioVoiceService);
exports.default = AudioVoiceService.getSingleton();
